import * as types from './projects.types';
export const projectsPageSelectors: types.IProjectsPageSelectors = {
  selectProjects: (state) => state.page.projects.projectIds,
};
